import { createFileRoute } from '@tanstack/react-router';
import { DragAndDropProvider } from '@/components/shared/dnd-kit/drag-and-drop';
import { EmployeeDashboard } from '@/components/employee/dashboard/employee-dashboard';

export const Route = createFileRoute('/(app)/employee/dashboard/')({
  component: EmployeeDashboardPage,
});

function EmployeeDashboardPage() {
  return (
    <DragAndDropProvider>
      <EmployeeDashboard />
    </DragAndDropProvider>
  );
}
